import React from "react";
import { DatePicker } from "antd";
import { dateTimeFormat, dateFormat, dateFormatTwo, timeHrMin, timeHrMinSec, startTimeToday, endTimeToday, dateTimeFormat4 } from "@/lib/dateTime";

const { RangePicker } = DatePicker;

interface props {
  attributeObject?: any,
  value?: any,
  onChange?: any,
  limitDay?: number,
  format?: string,
  minuteStep?: number
}

interface state {
  // dates: Array<any>,
  // hackValue: any,
  // valueState: any,
}

class ReRangePicker extends React.Component<props, state> {
  // state = {
  //   dates: [] as never as any,
  //   hackValue: undefined,
  //   valueState: [],
  // };

  // componentDidMount() {
  // if (this.props?.value) {
  //   this.setState({ valueState: this.props.value });
  // }
  // }

  // componentDidUpdate(prevProps: any) {
  // if (prevProps.value !== this.props.value) {
  //   this.setState({ valueState: this.props.value });
  // }
  // }

  // 動態設定date range，目前有bug，暫不使用
  // range = (start: number, end: number) => {
  //   const result: Array<number> = [];
  //   for (let i = start; i < end; i++) {
  //     result.push(i);
  //   }
  //   return result;
  // }

  // 動態設定date range，目前有bug，暫不使用
  // disabledDate = (current: any) => {
  //   const { dates } = this.state;
  //   const { limitDay = 0 } = this.props;
  //   if (!limitDay || !dates || dates.length === 0) {
  //     return false;
  //   }
  //   const tooLate = dates[0] && current.diff(dates[0], 'days') > limitDay - 1;
  //   const tooEarly = dates[1] && dates[1].diff(current, 'days') > limitDay - 1;
  //   return tooEarly || tooLate;
  // };

  // 以3天區間為例，目前是 5-11 00:00:00 ~ 5-13 23:59:59，以後要改成 5-11 00:00:00 ~ 5-14 00:00:00 可使用
  // disabledTime = (date: any, partial: string) => {
  //   const { dates } = this.state;
  //   const { limitDay = 0 } = this.props;
  //   if (!limitDay || !dates || dates.length === 0 || !date) {
  //     return false;
  //   }
  //   const isLimit = partial === 'start'
  //     ? (dates[1] && dates[1].diff(date, 'days') === limitDay)
  //     : (dates[0] && date.diff(dates[0], 'days') === limitDay);
  //   return {
  //     disabledHours: () => isLimit ? this.range(1, 24) : this.range(0, 0),
  //     disabledMinutes: () => isLimit ? this.range(1, 60) : this.range(0, 0),
  //     disabledSeconds: () => isLimit ? this.range(1, 60) : this.range(0, 0),
  //   };
  // };

  // 動態設定date range，目前有bug，暫不使用
  // onOpenChange = (open: any) => {
  //   if (open) {
  //     this.setState({ dates: [], hackValue: [] });
  //   } else {
  //     this.setState({ hackValue: undefined });
  //   }
  // };

  // 動態設定date range，目前有bug，暫不使用
  // onChange = (val: any) => {
  //   this.props.onChange(val);
  //   this.setState({ valueState: val });
  // }

  getFormat = () => {
    const { format } = this.props;
    switch (format) {
      case 'dateFormat':
        return dateFormat;
      case 'dateFormatTwo':
        return dateFormatTwo;
      case 'timeHrMin':
        return timeHrMin;
      case 'timeHrMinSec':
        return timeHrMinSec;
      case 'dateTimeFormat4':
        return dateTimeFormat4;
      default:
        return dateTimeFormat;
    }
  }

  render() {
    const { attributeObject = {}, minuteStep } = this.props;
    // const { hackValue, valueState } = this.state;

    return (
      <RangePicker
        {...this.props}
        showTime={{ defaultValue: [startTimeToday, endTimeToday] }}
        format={this.getFormat()}
        allowClear={false}
        minuteStep={minuteStep}
        // value={hackValue || valueState}
        // disabledDate={this.disabledDate}
        // disabledTime={this.disabledTime}
        // onCalendarChange={(val: any) => this.setState({ dates: val })}
        // onOpenChange={this.onOpenChange}
        // onChange={this.onChange}
        {...attributeObject}
      />
    );
  }
}

export default (ReRangePicker);
